// extracted by mini-css-extract-plugin
export var bodyRow = "_ff-d";
export var cardColumns = "_ff-e";
export var ellipsesOverflow = "_ff-2";
export var flatBottomCorners = "_ff-3";
export var flatTopCorners = "_ff-4";
export var headerActionsDropdown = "_ff-f";
export var headerBottomRow = "_ff-c";
export var headerTopRow = "_ff-b";
export var orderDetailsWrapper = "_ff-0";
export var orderInfoContainer = "_ff-1";
export var productDetails = "_ff-9";
export var productImage = "_ff-5";
export var responsiveTable = "_ff-8";
export var shipmentContainer = "_ff-a";
export var tableBottomLeft = "_ff-6";
export var tableBottomRight = "_ff-7";